import {
  DeleteSavedContentItemDocument,
  MarkCompletedDocument,
  MarkViewedDocument, RestartStudyDocument,
  SaveContentItemDocument,
} from './generated/graphql'
import { executeGraphQuery } from '~/utils/graphql/client'

export async function setBookmarkSaved(contentId: string | undefined | null, save: boolean) {
  if (!contentId || typeof window === 'undefined') return
  if (save) {
    await executeGraphQuery(SaveContentItemDocument, { id: contentId })
  }
  else {
    await executeGraphQuery(DeleteSavedContentItemDocument, { id: contentId })
  }
}

export async function markViewed(contentId: string | undefined | null, childContentId: string | undefined | null = undefined) {
  if (!contentId || typeof window === 'undefined') return
  await executeGraphQuery(MarkViewedDocument, { id: contentId, childContentId: childContentId })
}

export async function markCompleted(contentId: string | undefined | null, childContentId: string | undefined | null = undefined) {
  if (!contentId || typeof window === 'undefined') return
  await executeGraphQuery(MarkCompletedDocument, { id: contentId, childContentId: childContentId })
  window.dispatchEvent(new Event('session-completed'))
}

export async function restartStudy(slug: string) {
  if (typeof window === 'undefined') return
  const result = await executeGraphQuery(RestartStudyDocument, { slug: slug })
  if (!result?.restartStudy) {
    throw new Error('error beginning study')
  }
}
